import {
  Admonition,
  AdmonitionBody,
  AdmonitionFooter,
  AdmonitionHeader,
  AdmonitionTitle,
  Link,
} from '@apollo/orbit';
import React from 'react';

import { GraphRef } from 'src/app/graph/hooks/useGraphRef';
import { cloudSettingsRouteConfig } from 'src/app/graph/routes';
import {
  CloudProvider,
  RouterStatus,
  ShardStatus,
} from 'src/lib/graphqlTypes/types';

import { getAdmonitionProps } from './helpers';

export const CloudRouterDetailsAdmonition = ({
  status,
  nextStatus,
  shardStatus,
  graphRef,
  provider,
}: {
  status: RouterStatus;
  nextStatus?: RouterStatus | null;
  shardStatus?: ShardStatus;
  graphRef: GraphRef;
  durationBeforeDeleteSecs?: number;
  provider?: CloudProvider;
}) => {
  const admonitionProps = getAdmonitionProps(status, shardStatus, provider);

  if (!admonitionProps) return null;

  const { variant, title, body } = admonitionProps;

  const showSettingsLink =
    nextStatus === RouterStatus.SLEEPING || nextStatus === RouterStatus.DELETED;

  return (
    <Admonition variant={variant} data-testid="admonition">
      <AdmonitionHeader>
        <AdmonitionTitle>{title}</AdmonitionTitle>
      </AdmonitionHeader>
      <AdmonitionBody>{body}</AdmonitionBody>
      {showSettingsLink && (
        <AdmonitionFooter>
          <Link
            to={cloudSettingsRouteConfig.path({
              ...graphRef,
              tab: 'configuration',
            })}
          >
            Router settings
          </Link>
        </AdmonitionFooter>
      )}
    </Admonition>
  );
};
